class QueryString {
  static getParams(query) {
    const filteredParams = {}
    return (/^[?#]/.test(query) ? query.slice(1) : query)?.split('&').reduce((params, param) => {
      const [key, value] = param.split('=')
      filteredParams[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
      return filteredParams
    }, {})
  }
}

export default QueryString
